export { default } from 'cccisd-game-crooks-and-robbers';
